import { fetchTxsRequest } from "actions";
import { BBABalance, BlockNumber } from "components/blockchain";
import { TxHash } from "components/common/TxHash";
import Pagination from "components/datatable/pagination";
import Table from "components/datatable/table";
import { TxInterface } from "interfaces/tx.interface";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { RootState } from "reducers";
import { AppDispatch } from "store";
import { formatNumber } from "utils";

const Transactions = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { txs } = useSelector((state: RootState) => state.txs);

  useEffect(() => {
    dispatch(fetchTxsRequest(txs.meta.page, txs.meta.take));
  }, [dispatch, txs.meta.page, txs.meta.take]);

  // Define the columns with optional "render" for custom display
  const columns = [
    {
      title: "Tx Hash",
      render: (value: any, tx: TxInterface) => (
        <>
          <TxHash hash={tx.signature} link truncate={16} />
          <p className="text-xsmall text-gray-700">
            {moment.unix(tx.block?.block_time).fromNow()}
          </p>
        </>
      ),
    },
    {
      title: "Block Height",
      render: (value: any, tx: TxInterface) => (
        <BlockNumber height={tx.block_number} link />
      ),
    },
    {
      title: "Fee",
      render: (value: any, tx: TxInterface) => <BBABalance daltons={tx.fee} />,
    },
  ];

  return (
    <>
      <>
        {/* <div className="mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="box overflow-hidden bg-white dark:bg-darkPrimary">
            <div className="mb-2 grid grid-cols-1 gap-4 py-5 md:grid-cols-2 md:px-5 xl:grid-cols-4">
              <Widget
                icon={<BiSolidNotepad className="h-7 w-7" />}
                title={"Transactions (24H)"}
                border="md:border-r-[1px]"
                subtitle={
                  <span>
                    $1.2545 <span className="text-green-600">(+62.54%)</span>
                  </span>
                }
              />
              <Widget
                icon={<BiSolidNotepad className="h-7 w-7" />}
                title={"Pending Transactions (1H)"}
                border="xl:border-r-[1px]"
                subtitle={
                  <span>
                    15.75T <span className="text-green-600">(+3.65%)</span>
                  </span>
                }
              />
              <Widget
                icon={<BiSolidNotepad className="h-7 w-7" />}
                title={"Network Transaction Fee (24H)"}
                border="md:border-r-[1px]"
                subtitle={
                  <span>
                    $0.0000547 <span className="">($0.00005)</span>
                  </span>
                }
              />
              <Widget
                icon={<BiSolidNotepad className="h-7 w-7" />}
                title={"AVG. Transaction Fee (24H)"}
                border="border-none"
                subtitle={
                  <span>
                    $1.2545 <span className="text-green-600">(+62.54%)</span>
                  </span>
                }
              />
            </div>
          </div>
        </div> */}
        <div className="mb-12 mt-6 px-2.5 md:px-3 lg:px-5">
          <div className="box overflow-hidden bg-white dark:bg-darkPrimary">
            <div className="mt-5 flex flex-col">
              <div className="flex w-full flex-row flex-wrap items-center justify-between gap-1 px-5 py-4">
                <div className="text-large not-italic">
                  More than {formatNumber(txs.meta.itemCount, 0)} transactions
                  found
                </div>
              </div>
            </div>

            {/* TXS List */}
            <Table
              columns={columns}
              data={txs.data}
              tableClassName="table w-full"
            />

            {/* TXS Paginations */}
            <Pagination
              page={txs.meta.page}
              totalPage={txs.meta.pageCount}
              hasPrevPage={txs.meta.hasPreviousPage}
              hasNextPage={txs.meta.hasNextPage}
              onPageChange={(page) => {
                dispatch(fetchTxsRequest(page, txs.meta.take));
              }}
              onTakeChange={(take) => {
                dispatch(fetchTxsRequest(1, take));
              }}
            />
            {/* End Paginations */}
          </div>
        </div>
      </>
      <ReactTooltip
        id="txs-tip"
        place="right"
        effect="solid"
        class="custom-tooltip right"
      />
    </>
  );
};

export default Transactions;
